import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DisbursmentFilterComponent } from './disbursment-filter.component';
import { MaterialModule } from 'src/app/shared/material/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DatePickerCustomModule } from "src/app/shared/components/date-picker-custom/date-picker-custom.module";



@NgModule({
  declarations: [
    DisbursmentFilterComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    ReactiveFormsModule,
    FormsModule,
    DatePickerCustomModule
],
  exports:[
    DisbursmentFilterComponent
  ]
})
export class DisbursmentFilterModule { }
